<form id="clientEditForm" [formGroup]="clientEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="name" class="control-label required">{{'i18n.shared.fields.name' | translate}}</label>
      <input id="name" name="name" type="text" autocomplete="off" class="form-control" formControlName="name" />
      <app-error-messages [control]="clientEditForm.controls.name"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="address" class="control-label">{{'i18n.shared.fields.address' | translate}}</label>
      <input id="address" name="address" type="text" autocomplete="off" class="form-control" formControlName="address" />
      <app-error-messages [control]="clientEditForm.controls.address"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="zip" class="control-label">{{'i18n.shared.fields.zip' | translate}}</label>
      <input id="zip" name="zip" type="text" autocomplete="off" class="form-control" formControlName="zip" />
      <app-error-messages [control]="clientEditForm.controls.zip"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="city" class="control-label">{{'i18n.shared.fields.city' | translate}}</label>
      <input id="city" name="city" type="text" autocomplete="off" class="form-control" formControlName="city" />
      <app-error-messages [control]="clientEditForm.controls.city"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="email" class="control-label">{{'i18n.shared.fields.email' | translate}}</label>
      <input id="email" name="email" type="text" autocomplete="off" class="form-control" formControlName="email" />
      <app-error-messages [control]="clientEditForm.controls.email"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="phoneNumber" class="control-label">{{'i18n.shared.fields.phone' | translate}}</label>
      <input id="phoneNumber" name="phoneNumber" type="text" autocomplete="off" class="form-control" formControlName="phoneNumber" />
      <app-error-messages [control]="clientEditForm.controls.phoneNumber"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="dataRetentionPeriodInDays"
        class="d-block required">{{'i18n.domain.client-administration.overview.form.dataRetentionPeriodInDays' | translate}}</label>
      <div class="position-relative">
        <input id="dataRetentionPeriodInDays" name="dataRetentionPeriodInDays" type="number"
          autocomplete="off" class="form-control input-field-with-unit--wide" [min]="31"
          formControlName="dataRetentionPeriodInDays" appNumericDirective />
        <span class="multichar-unit">{{'i18n.domain.client-administration.overview.form.unit-days' | translate}}</span>
        <app-error-messages [control]="clientEditForm.controls.dataRetentionPeriodInDays"></app-error-messages>
      </div>
    </div>
    <div class="form-group col-md-6">
      <label for="clientIdent"
        class="control-label required">{{'i18n.shared.fields.clientIdent' | translate}}</label>
      <input id="clientIdent" name="clientIdent" type="text" autocomplete="off" class="form-control" formControlName="clientIdent" />
      <app-error-messages [control]="clientEditForm.controls.clientIdent"></app-error-messages>
    </div>
  </div>
  <ejs-accordion>
    <e-accordionitems>
      <e-accordionitem>
        <ng-template #header>
          <div>{{'i18n.domain.client-administration.overview.accordions.settings' | translate}}</div>
        </ng-template>
        <ng-template #content>
          <div class="form-row row">
            <div class="form-group col-md-6">
              <label class="d-block">{{'i18n.domain.client-administration.overview.form.automaticParkingSchedulesEnabled' | translate}}</label>
              <app-yes-no-group-button id="automaticParkingSchedulesEnabled" formControlName="automaticParkingSchedulesEnabled"></app-yes-no-group-button>
            </div>
            <div class="form-group col-md-6">
              <label for="automaticParkingScheduleToleranceInMinutes"
                class="d-block">{{'i18n.domain.client-administration.overview.form.automaticParkingScheduleToleranceInMinutes' | translate}}</label>
              <div class="position-relative">
                <input id="automaticParkingScheduleToleranceInMinutes"
                  name="automaticParkingScheduleToleranceInMinutes"
                  type="number"
                  autocomplete="off"
                  class="form-control input-field-with-unit--wide" [min]="0"
                  formControlName="automaticParkingScheduleToleranceInMinutes"
                  appNumericDirective />
                <span class="multichar-unit">min</span>
                <app-error-messages [control]="clientEditForm.controls.automaticParkingScheduleToleranceInMinutes"></app-error-messages>
              </div>
            </div>
          </div>
          @if (!isEdit) {
            <div class="form-row row">
              <div class="form-group col-md-6">
                <label class="d-block">{{'i18n.domain.client-administration.overview.form.auditLogEnabled' | translate}}</label>
                <app-yes-no-group-button id="auditLogEnabled" formControlName="auditLogEnabled"></app-yes-no-group-button>
              </div>
            </div>
          } @else {
            <div class="form-row row">
              <div class="form-group col-md-6">
                <label class="d-block">{{'i18n.domain.client-administration.overview.form.auditLogEnabled' | translate}}</label>
                <app-yes-no-group-button id="auditLogEnabled" formControlName="auditLogEnabled"></app-yes-no-group-button>
              </div>
              <div class="form-group col-md-6">
                <label class="d-block">{{'i18n.domain.client-administration.overview.form.connectionMode' | translate}}</label>
                <app-button-group id="connectionMode"
                  [fieldsEnum]="ConnectionMode" formControlName="connectionMode"
                  [translateKey]="'i18n.domain.client-administration.enums.connectionMode.'">
                </app-button-group>
              </div>
            </div>
            <div class="form-row row">
              <div class="form-group col-md-6">
                <label class="d-block">{{'i18n.domain.client-administration.overview.form.enableLPRPictureStorage' | translate}}</label>
                <app-yes-no-group-button id="enableLPRPictureStorage" formControlName="enableLPRPictureStorage"></app-yes-no-group-button>
              </div>
              <div class="form-group col-md-6">
                <label class="d-block">{{'i18n.domain.client-administration.overview.form.enableLPRPictureStorageOnOffense' | translate}}</label>
                <app-yes-no-group-button id="enableLPRPictureStorageOnOffense" formControlName="enableLPRPictureStorageOnOffense"></app-yes-no-group-button>
              </div>
            </div>
          }
          <div class="form-row row">
            @if (isEdit) {
              <div class="form-group col-md-6">
                <label class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
                <app-yes-no-group-button id="isActive" formControlName="isActive"></app-yes-no-group-button>
              </div>
            }
            <div class="form-group col-md-6">
              <label class="d-block">{{'i18n.domain.client-administration.overview.form.qrCodeIdentificationEnabled' | translate}}</label>
              <app-yes-no-group-button id="qrCodeIdentificationEnabled" formControlName="qrCodeIdentificationEnabled"></app-yes-no-group-button>
            </div>
          </div>
          @if (isEdit) {
            <div class="form-row row">
              <div class="form-group col-md-6">
                <button type="button" class="btn btn-primary"
                  (click)="openPriceModelDialog()">
                  <i class="e-icons icon-finance"></i>
                  {{'i18n.domain.client-administration.price-model.title' | translate}}
                </button>
                <app-price-model-edit #priceModelDialog></app-price-model-edit>
              </div>
            </div>
          }
        </ng-template>
      </e-accordionitem>

      <e-accordionitem>
        <ng-template #header>
          <div>{{'i18n.domain.client-administration.overview.accordions.custom-fields' | translate}}</div>
        </ng-template>
        <ng-template #content>
          <div class="form-row row">
            <div class="form-group col-md-4">
              <label for="custom1Name"
                class="custom1Name-label">{{'i18n.domain.client-administration.overview.fields.custom1Name' | translate}}</label>
              <input id="custom1Name" name="custom1Name" type="text" autocomplete="off" class="form-control" formControlName="custom1Name" />
              <app-error-messages [control]="clientEditForm.controls.custom1Name"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="custom2Name"
                class="custom2Name-label">{{'i18n.domain.client-administration.overview.fields.custom2Name' | translate}}</label>
              <input id="custom2Name" name="custom2Name" type="text" autocomplete="off" class="form-control" formControlName="custom2Name" />
              <app-error-messages [control]="clientEditForm.controls.custom2Name"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="custom3Name"
                class="custom3Name-label">{{'i18n.domain.client-administration.overview.fields.custom3Name' | translate}}</label>
              <input id="custom3Name" name="custom3Name" type="text" autocomplete="off" class="form-control" formControlName="custom3Name" />
              <app-error-messages [control]="clientEditForm.controls.custom3Name"></app-error-messages>
            </div>
          </div>

          <div class="form-row row">
            <div class="form-group col-md-4">
              <label for="custom4Name"
                class="custom4Name-label">{{'i18n.domain.client-administration.overview.fields.custom4Name' | translate}}</label>
              <input id="custom4Name" name="custom4Name" type="text" autocomplete="off" class="form-control" formControlName="custom4Name" />
              <app-error-messages [control]="clientEditForm.controls.custom4Name"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="custom5Name"
                class="custom5Name-label">{{'i18n.domain.client-administration.overview.fields.custom5Name' | translate}}</label>
              <input id="custom5Name" name="custom5Name" type="text" autocomplete="off" class="form-control" formControlName="custom5Name" />
              <app-error-messages [control]="clientEditForm.controls.custom5Name"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="custom6Name"
                class="custom6Name-label">{{'i18n.domain.client-administration.overview.fields.custom6Name' | translate}}</label>
              <input id="custom6Name" name="custom6Name" type="text" autocomplete="off" class="form-control" formControlName="custom6Name" />
              <app-error-messages [control]="clientEditForm.controls.custom6Name"></app-error-messages>
            </div>
          </div>

          <div class="form-row row">
            <div class="form-group col-md-4">
              <label for="custom7Name"
                class="custom7Name-label">{{'i18n.domain.client-administration.overview.fields.custom7Name' | translate}}</label>
              <input id="custom7Name" name="custom7Name" type="text" autocomplete="off" class="form-control" formControlName="custom7Name" />
              <app-error-messages [control]="clientEditForm.controls.custom7Name"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="custom8Name"
                class="custom8Name-label">{{'i18n.domain.client-administration.overview.fields.custom8Name' | translate}}</label>
              <input id="custom8Name" name="custom8Name" type="text" autocomplete="off" class="form-control" formControlName="custom8Name" />
              <app-error-messages [control]="clientEditForm.controls.custom8Name"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="custom9Name"
                class="custom9Name-label">{{'i18n.domain.client-administration.overview.fields.custom9Name' | translate}}</label>
              <input id="custom9Name" name="custom9Name" type="text" autocomplete="off" class="form-control" formControlName="custom9Name" />
              <app-error-messages [control]="clientEditForm.controls.custom9Name"></app-error-messages>
            </div>
          </div>
        </ng-template>
      </e-accordionitem>
    </e-accordionitems>
  </ejs-accordion>
</form>
